/**************************************************
 * Nombre:       Tarjeta_Vista_Sets
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {Splide, SplideSlide} from "@splidejs/react-splide";
import Tarjeta_Vista_Producto from "./Tarjeta_Vista_Producto";
import Tarjeta_Producto from "./Tarjeta_Producto";
import {useEffect, useState} from "react";


const Tarjeta_Vista_Sets = ({arrItem = []}) => {
    const [productos, setProductos] = useState([])


    const obtenerProductosNoDuplicados = (arr) => {


        let newArr = []
        for (let i = 0; i < arr.length; i++) {
            if (arr[i].productos && arr[i].productos.length) {
                newArr.push(...arr[i].productos)
            }
        }


        setProductos(newArr)

    }

    useEffect(() => {
        obtenerProductosNoDuplicados(arrItem)
    }, [arrItem])
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}>

                {arrItem.map((it, index) => {
                    return (
                        <Grid container size={{xs: 12, sm: 6, md: 4}} sx={{ml: -0.1, mr: -0.1}}>
                            <Splide
                                aria-label="My Favorite Images" style={{width: '100%'}}
                                options={{
                                    autoplay: true,
                                    speed: 1500,
                                    rewind: true,
                                    perPage: 1,
                                    arrows: true,
                                    pagination: false,
                                    width: '100%',
                                    drag: 'false',
                                    interval: 5000,
                                    noDrag: true,
                                    type: 'fade',

                                }}
                            >

                                {it.imgs && it.imgs.map((srcImg, index) => {
                                    return (
                                        <SplideSlide key={`qe${index}`}>
                                            <Tarjeta_Vista_Producto item={srcImg} productos={it.productos}/>
                                        </SplideSlide>
                                    )
                                })}


                            </Splide>
                        </Grid>
                    )
                })}


            </Grid>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
                sx={{mt: 4, px: 2}}
            >


                {productos.map((it, index) => {
                    return (
                        <Grid container size={{xs: 6, sm: 3, md: 2}}>
                            <Tarjeta_Producto item={it}/>
                        </Grid>
                    )
                })}


            </Grid>


        </Grid>
    )

}
export default Tarjeta_Vista_Sets